module.exports = __webpack_public_path__ + "img/pic-s1-kreatywna-druzynowa.png";